import React, { useContext } from 'react';
import { PanelPresetsContext } from '../context';
import ColorPresets from './ColorPresets';

var PanelPresets = function PanelPresets() {
  var _useContext = useContext(PanelPresetsContext),
      prefixCls = _useContext.prefixCls,
      value = _useContext.value,
      presets = _useContext.presets,
      onChange = _useContext.onChange;

  return Array.isArray(presets) ? /*#__PURE__*/React.createElement(ColorPresets, {
    value: value,
    presets: presets,
    prefixCls: prefixCls,
    onChange: onChange
  }) : null;
};

export default PanelPresets;